/*=========================================================================================
  File Name: sidebarItems.js
  Description: Sidebar Items list. Add / Remove menu items from here.
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


export default [
  // for admin
  {
    url: '/',
    name: 'Dashboard',
    slug: 'AdminDashboard',
    icon: 'FeatherIcon',
    i18n: 'Dashboard',
    meta: 'admin'
  },
  {
    url: '/customers',
    name: 'Customers',
    slug: 'Customers',
    icon: 'SmileIcon',
    i18n: 'Customers',
    meta: 'admin'
  },
  {
    header: 'Nursing Homes',
    icon: 'PackageIcon',
    i18n: 'Nursing Homes',
    meta: 'admin',
    items:[
      {
        url: '/nursing-homes',
        name: 'Nursing Homes',
        slug: 'nursing-homes',
        icon: 'HomeIcon',
        i18n: 'Nursing Homes',
        meta: 'admin'
	  },
	 {
        url: '/nh-payments',
        name: 'Payments',
        slug: 'nh-payments',
        icon: 'DollarSignIcon',
        i18n: 'Payments',
        meta: 'admin'
	 }
    ]
  },
  {
    url: '/coupons',
    name: 'Coupons',
    slug: 'admin-coupons',
    icon: 'TagIcon',
    i18n: 'Coupons',
    meta: 'admin'
  },

  // for Nursing home admin
  {
    url: '/nh-admin',
    name: 'Dashboard',
    slug: 'NHDashboard',
    icon: 'HomeIcon',
    i18n: 'Dashboard',
    meta: 'nh_admin'
  },
  {
    url: '/nh-coupons',
    name: 'Coupons',
    slug: 'nh-coupons',
    icon: 'TagIcon',
    i18n: 'Coupons',
    meta: 'nh_admin'
  },
  {
    url: '/nh-invitations',
    name: 'Invitations',
    slug: 'nh-invitation',
    icon: 'MailIcon',
    i18n: 'Invitations',
    meta: 'nh_admin'
  },
  {
    url: '/nh-albums',
    name: 'Photobooks',
    slug: 'nh-albums',
    icon: 'ApertureIcon',
    i18n: 'Photobooks',
    meta: 'nh_admin'
  },

  // for nursing home staff
  {
    url: '/nhs-albums',
    name: 'Photobooks',
    slug: 'nhs-albums',
    icon: 'ApertureIcon',
    i18n: 'Photobooks',
    meta: 'nh_staff'
  }

]
